export default {
  // https://i18n.nuxtjs.org/docs/guide/locale-fallback
  fallbackLocale: 'nb',
}
